import { render, staticRenderFns } from "./VersionEditor.vue?vue&type=template&id=0fdc276d&scoped=true&"
import script from "./VersionEditor.vue?vue&type=script&lang=js&"
export * from "./VersionEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdc276d",
  null
  
)

export default component.exports